import React from 'react';
import { Tag } from 'lucide-react';

const sales = [
  {
    id: 1,
    product: 'Toor Dal',
    originalPrice: 7.99,
    salePrice: 5.99,
    image: 'https://images.unsplash.com/photo-1585996746804-0a9f2069419b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 2,
    product: 'Masala Tea',
    originalPrice: 4.99,
    salePrice: 3.49,
    image: 'https://images.unsplash.com/photo-1561336526-2914f13ceb36?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 3,
    product: 'Ghee',
    originalPrice: 12.99,
    salePrice: 9.99,
    image: 'https://images.unsplash.com/photo-1612197526325-9c6cd5a7d886?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }
];

export default function WeeklySales() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2 mb-8">
          <Tag className="text-[#568203]" size={24} />
          <h2 className="text-3xl font-bold text-gray-800">Weekly Special Offers</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {sales.map((item) => (
            <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src={item.image} alt={item.product} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-xl font-semibold mb-2">{item.product}</h3>
                <div className="flex items-center gap-2">
                  <span className="text-gray-500 line-through">${item.originalPrice}</span>
                  <span className="text-2xl font-bold text-[#568203]">${item.salePrice}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}